module.exports = __webpack_public_path__ + "static/media/vaadin.43d5fe97.svg";